(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function initHerkunftToggle() {
      var select = document.getElementById('ContactForm-herkunft');
      var freitext = document.getElementById('ContactForm-herkunft-freitext');
      if (!select || !freitext || select.dataset.herkunftBound) return;
      select.dataset.herkunftBound = 'true';

      function toggle() {
        var isOther = select.value === 'Etwas anderes';
        freitext.hidden = !isOther;
        freitext.required = isOther;
        if (!isOther) freitext.value = '';
      }

      select.addEventListener('change', toggle);
      toggle();
    }

    function initAdRefField() {
      var field = document.getElementById('ContactForm-ad-ref');
      if (!field || field.dataset.adRefBound) return;
      field.dataset.adRefBound = 'true';

      try {
        var raw = window.sessionStorage ? window.sessionStorage.getItem('jarvis_ad_ref') : null;
        if (!raw) return;
        var data = JSON.parse(raw);
        var parts = [];
        if (data.gclid || data.gbraid || data.wbraid) parts.push('Google-Ads-Klick-ID vorhanden');
        if (data.utm_source) parts.push('Quelle: ' + data.utm_source);
        if (data.utm_medium) parts.push('Medium: ' + data.utm_medium);
        if (data.utm_campaign) parts.push('Kampagne: ' + data.utm_campaign);
        if (data.utm_term) parts.push('Keyword: ' + String(data.utm_term).slice(0, 60));
        if (data.matchtype) parts.push('Treffertyp: ' + String(data.matchtype).slice(0, 20));
        if (data.utm_content) parts.push('Anzeigengruppe: ' + String(data.utm_content).slice(0, 30));
        if (data.landing_path) parts.push('Landing: ' + data.landing_path);
        field.value = parts.join(' | ');
      } catch (e) {
        // kaputtes/veraltetes sessionStorage-Format - Feld bleibt einfach leer
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initHerkunftToggle();
        initAdRefField();
      });
    } else {
      initHerkunftToggle();
      initAdRefField();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
